<template>
	<div class="menu_block">
		<transition name="slide-fade" mode="out-in">
			<ul class="row imc_box" v-if="docs_create.length > 0">
				<li v-for="item in docs_create" class="mt-3 mb-3 col-md-4 col-xs-6 col-lg-3 col-xl-2 ">
					<a v-bind:href="item.url" @click.prevent="setActiveMenu(item)" :class="is_active(item)" class="bg-primary-500 color-primary-500"
					   :title="item.title">
						<div class="menu_item menu_item rounded hover-bg shadow-hover text-center shadow-sm border ">
							<div class="icon">
								<i :class="item.icon" class="fal"></i>
							</div>

							<div class="content">
								<h5 class="name">{{item.title}}</h5>
							</div>
						</div>
					</a>
				</li>
			</ul>
		</transition>
	</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
	name: "menu_block",

	data() {
		return {
			show_anim:false,
			docs_create: [],
		}
	},

	created() {
		this.getMenuItems();
	},
	methods: {
		async getMenuItems() {
			await api.get('memorandum/menu').then(({data}) => {
				this.is_load = true;
				if (data.status === "operation_success") {
					this.docs_create = data.data;
				} else {
					this.docs_create = [];
				}
			}).catch(err => {
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
				this.is_load = false;
			});
		},

		setActiveMenu(item) {
			if (this.selected_menu != null) {
				if (this.selected_menu.id == item.id) {
					this.$store.dispatch('memorandum_create/DELETE_ACTIVE_MENU');
					return;
				}
			}

			this.$store.dispatch('memorandum_create/SET_ACTIVE_MENU', item);
		},

		is_active(curr) {
			if (this.selected_menu != null) {
				if (curr.id == this.selected_menu.id) {
					return 'active';
				}
			}
			return '';
		}
	},
	computed: {

		...mapGetters({
			'mem_create': "memorandum_create/getMemCreateField",
		}),

		selected_menu() {
			return this.mem_create('active_menu');
		}

	}
}
</script>

<style scoped>
	.slide-fade-enter-active {
		transition: all .3s ease;
	}

	.slide-fade-leave-active {
		transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}

	.slide-fade-enter, .slide-fade-leave-to
		/* .slide-fade-leave-active до версии 2.1.8 */
	{
		transform: translateX(10px);
		opacity: 0;
	}
</style>
